import React from 'react';

class SurveyAddress extends React.Component {
    render() {
        return (
            <div className="mail"><h2 className="mail__title">Адрес проекта</h2>
                <a className="mail__btn" href="https://survey-studio.com/">Перейти на сайт: survey-studio.com</a>
                <div className="mail__envelope"><i className="fa fa-envelope-o"></i>
                    <a className="mail__envelope-link" href="mailto:info@survey-studio.com">info@survey-studio.com</a>
                </div>
            </div>
        )
    }
}

export default SurveyAddress;


// WEBPACK FOOTER //
// ./src/Components/SurveyStudio/SurveyAddress.js